// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_WZV","cls2":"SearchNavbarComponents-cls2_pOR SearchNavbarComponents-cls1_WZV"};